import ArrowDown from '../../../assets/images/icons/arrowDown.svg?react';
import ArrowDownSmall from '../../../assets/images/icons/arrowDownSmall.svg?react';
import ArrowLeft from '../../../assets/images/icons/arrowLeft.svg?react';
import ArrowLeftSmall from '../../../assets/images/icons/arrowLeftSmall.svg?react';
import ArrowRight from '../../../assets/images/icons/arrowRight.svg?react';
import ArrowRightSmall from '../../../assets/images/icons/arrowRightSmall.svg?react';
import ArrowUp from '../../../assets/images/icons/arrowUp.svg?react';
import ArrowUpSmall from '../../../assets/images/icons/arrowUpSmall.svg?react';
import AppStore from '../../../assets/images/icons/app-store.svg?react';
import AlertTriangle from '../../../assets/images/icons/alertTriangle.svg?react';
import Badge from '../../../assets/images/icons/badge.svg?react';
import Bolt from '../../../assets/images/icons/bolt.svg?react';
import Broom from '../../../assets/images/icons/broom.svg?react';
import Bulb from '../../../assets/images/icons/bulb.svg?react';
import Camera from '../../../assets/images/icons/camera.svg?react';
import Car from '../../../assets/images/icons/car.svg?react';
import Message from '../../../assets/images/icons/message.svg?react';
import Droplet from '../../../assets/images/icons/droplet.svg?react';
import Elevator from '../../../assets/images/icons/elevator.svg?react';
import Envelope from '../../../assets/images/icons/envelope.svg?react';
import Flame from '../../../assets/images/icons/flame.svg?react';
import House from '../../../assets/images/icons/house.svg?react';
import InfoCircle from '../../../assets/images/icons/infoCircle.svg?react';
import Keys from '../../../assets/images/icons/keys.svg?react';
import Leaf from '../../../assets/images/icons/leaf.svg?react';
import ShieldCheck from '../../../assets/images/icons/shieldCheck.svg?react';
import Speaker from '../../../assets/images/icons/speaker.svg?react';
import Wrench from '../../../assets/images/icons/wrench.svg?react';
import Calculator from '../../../assets/images/icons/calculator.svg?react';
import HeartPulse from '../../../assets/images/icons/heartPulse.svg?react';
import Paw from '../../../assets/images/icons/paw.svg?react';
import Percent from '../../../assets/images/icons/percent.svg?react';
import TrendingUp from '../../../assets/images/icons/trendingUp.svg?react';
import Umbrella from '../../../assets/images/icons/umbrella.svg?react';
import Wallet from '../../../assets/images/icons/wallet.svg?react';
import Building from '../../../assets/images/icons/building.svg?react';
import BuildingDefault from '../../../assets/images/icons/buildingDefault.svg?react';
import BuildingSelected from '../../../assets/images/icons/buildingSelected.svg?react';
import BullHorn from '../../../assets/images/icons/bullHorn.svg?react';
import Check from '../../../assets/images/icons/check.svg?react';
import Checkbox from '../../../assets/images/icons/checkbox.svg?react';
import CheckmarkCircle from '../../../assets/images/icons/checkmark-circle.svg?react';
import Checkmark from '../../../assets/images/icons/checkmark.svg?react';
import Components from '../../../assets/images/icons/components.svg?react';
import DeadlinesDefault from '../../../assets/images/icons/deadlinesDefault.svg?react';
import DeadlinesSelected from '../../../assets/images/icons/deadlinesSelected.svg?react';
import Document from '../../../assets/images/icons/document.svg?react';
import Download from '../../../assets/images/icons/download.svg?react';
import Edit from '../../../assets/images/icons/edit.svg?react';
import EditorBold from '../../../assets/images/icons/editor-bold.svg?react';
import EditorH1 from '../../../assets/images/icons/editor-h1.svg?react';
import EditorH2 from '../../../assets/images/icons/editor-h2.svg?react';
import EditorH3 from '../../../assets/images/icons/editor-h3.svg?react';
import EditorH4 from '../../../assets/images/icons/editor-h4.svg?react';
import EditorItalic from '../../../assets/images/icons/editor-italic.svg?react';
import EditorLink from '../../../assets/images/icons/editor-link.svg?react';
import EditorListOl from '../../../assets/images/icons/editor-list-ol.svg?react';
import EditorListUl from '../../../assets/images/icons/editor-list-ul.svg?react';
import EditorParagraph from '../../../assets/images/icons/editor-paragraph.svg?react';
import Email from '../../../assets/images/icons/email.svg?react';
import Feed from '../../../assets/images/icons/feed.svg?react';
import FeedSelected from '../../../assets/images/icons/feedSelected.svg?react';
import FileXlsx from '../../../assets/images/icons/fileXlsx.svg?react';
import FilesDefault from '../../../assets/images/icons/filesDefault.svg?react';
import FilesSelected from '../../../assets/images/icons/filesSelected.svg?react';
import Flag from '../../../assets/images/icons/flag.svg?react';
import GooglePlay from '../../../assets/images/icons/google-play.svg?react';
import Garage from '../../../assets/images/icons/garage.svg?react';
import Handshake from '../../../assets/images/icons/handshake.svg?react';
import HeaderBackground from '../../../assets/images/icons/headerBackground.svg?react';
import Home from '../../../assets/images/icons/home.svg?react';
import Horn from '../../../assets/images/icons/horn.svg?react';
import Info from '../../../assets/images/icons/info.svg?react';
import IssuesDefault from '../../../assets/images/icons/issuesDefault.svg?react';
import IssuesSelected from '../../../assets/images/icons/issuesSelected.svg?react';
import JudgeHammer from '../../../assets/images/icons/judgeHammer.svg?react';
import Key from '../../../assets/images/icons/key.svg?react';
import Lightning from '../../../assets/images/icons/lightning.svg?react';
import Logo from '../../../assets/images/icons/logo.svg?react';
import Logout from '../../../assets/images/icons/logout.svg?react';
import Notifications from '../../../assets/images/icons/notifications.svg?react';
import OtherServicesDefault from '../../../assets/images/icons/otherServicesDefault.svg?react';
import OtherServicesSelected from '../../../assets/images/icons/otherServicesSelected.svg?react';
import Phone from '../../../assets/images/icons/phone.svg?react';
import Plus from '../../../assets/images/icons/plus.svg?react';
import Poll from '../../../assets/images/icons/poll.svg?react';
import Printer from '../../../assets/images/icons/printer.svg?react';
import PollSelected from '../../../assets/images/icons/pollSelected.svg?react';
import Profile from '../../../assets/images/icons/profile.svg?react';
import ProfileDefault from '../../../assets/images/icons/profileDefault.svg?react';
import ProfileSelected from '../../../assets/images/icons/profileSelected.svg?react';
import QuestionCircle from '../../../assets/images/icons/question-circle.svg?react';
import RegisterDefault from '../../../assets/images/icons/registerDefault.svg?react';
import RegisterSelected from '../../../assets/images/icons/registerSelected.svg?react';
import RegistryCZUK from '../../../assets/images/icons/registryCZUK.svg?react';
import RegistryCompany from '../../../assets/images/icons/registryCompany.svg?react';
import RegistryInsolvency from '../../../assets/images/icons/registryInsolvency.svg?react';
import RegistryVat from '../../../assets/images/icons/registryVat.svg?react';
import Ribbon from '../../../assets/images/icons/ribbon.svg?react';
import Search from '../../../assets/images/icons/search.svg?react';
import Settings from '../../../assets/images/icons/settings.svg?react';
import Shield from '../../../assets/images/icons/shield.svg?react';
import Star from '../../../assets/images/icons/star.svg?react';
import Times from '../../../assets/images/icons/times.svg?react';
import Trash from '../../../assets/images/icons/trash.svg?react';
import UnitsDefault from '../../../assets/images/icons/unitsDefault.svg?react';
import UnitsSelected from '../../../assets/images/icons/unitsSelected.svg?react';
import Upload from '../../../assets/images/icons/upload.svg?react';
import Users from '../../../assets/images/icons/users.svg?react';

export const iconMap = {
  alertTriangle: AlertTriangle,
  appStore: AppStore,
  arrowDown: ArrowDown,
  arrowDownSmall: ArrowDownSmall,
  arrowLeft: ArrowLeft,
  arrowLeftSmall: ArrowLeftSmall,
  arrowRight: ArrowRight,
  arrowRightSmall: ArrowRightSmall,
  arrowUp: ArrowUp,
  arrowUpSmall: ArrowUpSmall,
  badge: Badge,
  bolt: Bolt,
  broom: Broom,
  building: Building,
  buildingDefault: BuildingDefault,
  buildingSelected: BuildingSelected,
  bulb: Bulb,
  bullHorn: BullHorn,
  camera: Camera,
  car: Car,
  check: Check,
  checkbox: Checkbox,
  'checkmark-circle': CheckmarkCircle,
  checkmark: Checkmark,
  components: Components,
  deadlinesDefault: DeadlinesDefault,
  deadlinesSelected: DeadlinesSelected,
  document: Document,
  download: Download,
  droplet: Droplet,
  edit: Edit,
  'editor-bold': EditorBold,
  'editor-h1': EditorH1,
  'editor-h2': EditorH2,
  'editor-h3': EditorH3,
  'editor-h4': EditorH4,
  'editor-italic': EditorItalic,
  'editor-link': EditorLink,
  'editor-list-ol': EditorListOl,
  'editor-list-ul': EditorListUl,
  'editor-paragraph': EditorParagraph,
  elevator: Elevator,
  email: Email,
  envelope: Envelope,
  feed: Feed,
  feedSelected: FeedSelected,
  fileXlsx: FileXlsx,
  filesDefault: FilesDefault,
  filesSelected: FilesSelected,
  flag: Flag,
  flame: Flame,
  garage: Garage,
  googlePlay: GooglePlay,
  handshake: Handshake,
  headerBackground: HeaderBackground,
  home: Home,
  horn: Horn,
  house: House,
  info: Info,
  infoCircle: InfoCircle,
  issuesDefault: IssuesDefault,
  issuesSelected: IssuesSelected,
  judgeHammer: JudgeHammer,
  key: Key,
  keys: Keys,
  leaf: Leaf,
  lightning: Lightning,
  logo: Logo,
  logout: Logout,
  message: Message,
  notifications: Notifications,
  otherServicesDefault: OtherServicesDefault,
  otherServicesSelected: OtherServicesSelected,
  phone: Phone,
  plus: Plus,
  poll: Poll,
  pollSelected: PollSelected,
  printer: Printer,
  profile: Profile,
  profileDefault: ProfileDefault,
  profileSelected: ProfileSelected,
  'question-circle': QuestionCircle,
  registerDefault: RegisterDefault,
  registerSelected: RegisterSelected,
  registryCZUK: RegistryCZUK,
  registryCompany: RegistryCompany,
  registryInsolvency: RegistryInsolvency,
  registryVat: RegistryVat,
  ribbon: Ribbon,
  search: Search,
  settings: Settings,
  shield: Shield,
  shieldCheck: ShieldCheck,
  speaker: Speaker,
  star: Star,
  times: Times,
  trash: Trash,
  unitsDefault: UnitsDefault,
  unitsSelected: UnitsSelected,
  upload: Upload,
  users: Users,
  wrench: Wrench,
  calculator: Calculator,
  heartPulse: HeartPulse,
  paw: Paw,
  percent: Percent,
  trendingUp: TrendingUp,
  umbrella: Umbrella,
  wallet: Wallet,
};

export type IconName = keyof typeof iconMap;
